const EXAMPLES = [
  {
    industry: 'Fashion & Apparel',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=stylish%20modern%20clothing%20flatlay%20on%20a%20clean%20white%20surface%2C%20trendy%20fashion%20items%20including%20jacket%20jeans%20and%20accessories%20neatly%20arranged%2C%20soft%20natural%20studio%20lighting%2C%20professional%20product%20photography%2C%20minimal%20aesthetic%2C%20no%20text%20overlay%2C%20high%20contrast%2C%20photorealistic%20ecommerce%20product%20shot&width=600&height=400&seq=ecom-ex-fashion-01&orientation=landscape',
    hook: 'Your wardrobe is calling for an upgrade. Answer it.',
    headline: 'New Arrivals Just Dropped. Free Shipping on Orders Over $50.',
    cta: 'Shop the Drop',
    platform: 'Instagram',
    platformIcon: 'ri-instagram-fill',
    result: '+310% more product page visits',
  },
  {
    industry: 'Home & Lifestyle',
    icon: 'ri-home-heart-line',
    image: 'https://readdy.ai/api/search-image?query=beautifully%20styled%20modern%20living%20room%20with%20premium%20home%20decor%20products%20including%20candles%20vases%20and%20cushions%20on%20a%20minimalist%20shelf%2C%20warm%20cozy%20ambient%20lighting%2C%20clean%20interior%20design%20aesthetic%2C%20professional%20lifestyle%20product%20photography%2C%20no%20text%2C%20photorealistic&width=600&height=400&seq=ecom-ex-home-01&orientation=landscape',
    hook: 'Your home should feel like a sanctuary. Here\'s how.',
    headline: 'Handpicked Home Essentials. 30-Day Free Returns.',
    cta: 'Shop Home Decor',
    platform: 'Facebook',
    platformIcon: 'ri-facebook-circle-fill',
    result: '2.9x more add-to-carts',
  },
  {
    industry: 'Health & Wellness',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=premium%20health%20supplement%20bottles%20and%20wellness%20products%20arranged%20on%20a%20clean%20marble%20surface%20with%20green%20plants%20and%20natural%20elements%2C%20bright%20airy%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20no%20text%20overlay%2C%20professional%20ecommerce%20shot%2C%20photorealistic&width=600&height=400&seq=ecom-ex-health-01&orientation=landscape',
    hook: 'You\'ve tried everything. This one actually works.',
    headline: 'Science-Backed. Customer-Approved. Try Risk-Free.',
    cta: 'Get 20% Off Today',
    platform: 'Google Ads',
    platformIcon: 'ri-google-fill',
    result: '4.3x return on ad spend',
  },
];

export default function EcommerceExamples() {
  return (
    <section className="py-20 lg:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">
            Real Ad Examples
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            Product-Specific Ads That Drive Purchases
          </h2>
          <p className="text-base text-stone-500 max-w-xl mx-auto">
            AdForge knows ecommerce. Here&apos;s what AI-generated{' '}
            <strong>ecommerce advertising</strong> looks like across real product categories.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {EXAMPLES.map((ex) => (
            <article
              key={ex.industry}
              className="bg-white rounded-2xl border border-stone-100 overflow-hidden flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={ex.image}
                  alt={`${ex.industry} ad example`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.platformIcon} text-sm text-stone-700`} />
                  </div>
                  <span className="text-xs font-semibold text-stone-700">{ex.platform}</span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1.5 bg-orange-500 rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.icon} text-xs text-white`} />
                  </div>
                  <span className="text-xs font-bold text-white">{ex.industry}</span>
                </div>
              </div>

              <div className="p-6 flex flex-col gap-3 flex-1">
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Hook</p>
                  <p className="text-sm text-stone-700 italic leading-relaxed">&ldquo;{ex.hook}&rdquo;</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Headline</p>
                  <p className="text-base font-bold text-stone-900 leading-snug">{ex.headline}</p>
                </div>
                <div className="mt-auto pt-4 border-t border-stone-100 flex items-center justify-between">
                  <span className="inline-block px-4 py-2 bg-orange-500 text-white text-xs font-bold rounded-lg whitespace-nowrap">
                    {ex.cta}
                  </span>
                  <span className="text-xs font-semibold text-green-600 bg-green-50 border border-green-100 rounded-full px-3 py-1">
                    {ex.result}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center text-sm text-stone-400 mt-8">
          AdForge also works for beauty, electronics, pet products, sports gear, food &amp; beverage, and more.{' '}
          <a href="/signup" className="text-orange-500 font-semibold hover:underline">Try it free →</a>
        </p>
      </div>
    </section>
  );
}
